import {
  CustomerPaymentItem,
  CustomerPaymentStatus,
} from '@/src/types/common/paymentGateway';

const EMPTY_VALUE = '-';

const statusI18nKeyMap: Record<CustomerPaymentStatus, string> = {
  [CustomerPaymentStatus.CHARGED]:
    'allOrders.orderDetail.paymentHistory_status_charged',
  [CustomerPaymentStatus.FAILED]: 'general.paymentStatus.failed',
  [CustomerPaymentStatus.REFUNDING]:
    'allOrders.orderDetail.paymentHistory_status_refunding',
  [CustomerPaymentStatus.REFUNDED]: 'general.status.refunded',
};

const getStatusI18nKey = (status: CustomerPaymentStatus | null | undefined) => {
  return status ? statusI18nKeyMap[status] : undefined;
};

const getGatewayLabel = (item: CustomerPaymentItem) => {
  return (
    item?.paymentMethodName?.trim() || item?.provider?.trim() || EMPTY_VALUE
  );
};

const getAppliedI18nKey = (item: CustomerPaymentItem) => {
  const status = item?.paymentDetail?.status;
  const appliedToOrder = item?.paymentDetail?.appliedToOrder;

  if (
    !status ||
    status === CustomerPaymentStatus.FAILED ||
    appliedToOrder === null ||
    appliedToOrder === undefined
  ) {
    return undefined;
  }

  return appliedToOrder ? 'general.yes' : 'general.no';
};

const canRefund = (item: CustomerPaymentItem) => {
  return (
    item?.paymentDetail?.status === CustomerPaymentStatus.CHARGED &&
    item?.paymentDetail?.appliedToOrder === false
  );
};

export { canRefund, getAppliedI18nKey, getGatewayLabel, getStatusI18nKey };
